import {Component, Inject} from '@angular/core';
import {MxFormErrorMessageService} from '../../../../services/mx-form-error-message.service';
import {MxField} from '../../services/mxField';
import {PrimitiveInputValue} from '../../services/mx-field-customizer.service';
import {MX_TRANSLATE_SERVICE_TOKEN, MxTranslateService} from '../../../../../../shared/services/mx-translate.service';

@Component({
    selector: 'mx-text-field',
    standalone: false,
    templateUrl: './mx-text-field.component.html'
})
export class MxTextFieldComponent extends MxField {

    constructor(public errorService: MxFormErrorMessageService,
                @Inject(MX_TRANSLATE_SERVICE_TOKEN) protected translateService: MxTranslateService) {
        super(errorService, translateService);
    }

    isViewUrl(): string {
        return this.fieldConfig && this.fieldConfig.viewUrlFn && this.fieldConfig.viewUrlFn();
    }

    openViewUrl(): string {
        if (this.fieldConfig && this.fieldConfig.viewUrlFn) {
            return this.fieldConfig.viewUrlFn();
        }
    }

    getValue = (): PrimitiveInputValue => {
        let value: string = this.form.get([this.name]) && this.form.get([this.name]).value;
        if (value === '') {
            value=null;
        }
        this.form.get([this.name]).setValue(value);
        this.form.get([this.name]).markAsDirty();
        return value;
    }

}
